import React, { useState } from "react";

const Product = ({ item, isBorder = true }) => {
  const [activeProdId, setActiveProdId] = useState(null);

  return (
    <a
      href="/product-details"
      className={`${
        isBorder ? "border" : ""
      } product  dm-sans position-relative text-decoration-none`}
      key={item.id}
      onMouseOver={() => setActiveProdId(item.id)}
      onMouseOut={() => setActiveProdId(null)}
    >
      <div className=" overflow-hidden">
        <img src={item.img_url} alt={item.name} />
      </div>

      <div
        className={
          activeProdId === item.id
            ? "product_option_visible"
            : "product_options"
        }
      >
        <div>
          <i className="bi bi-cart2"></i>
        </div>
        <div>
          <i className="bi bi-search"></i>
        </div>
        <div>
          <i className="bi bi-heart"></i>
        </div>
        <div>
          <i className="bi bi-arrows-angle-expand"></i>
        </div>
      </div>
      <div className="product-content">
        <h5>{item.name}</h5>
        <span>${item.price}</span>
      </div>
    </a>
  );
};

export default Product;
